<template>

  <div class="corretiva-lancamento ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="2">
                <label for="select-garagem">Garagem</label>     <!-- --{{this.value_garagem.map(a => a.id_filial)}}             -->
                <multiselect  v-model="value_garagem" required 
                  :options="garagens"                   
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a garagem" label="garagem" track-by="garagem" name="garagem"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2">
                <label for="select-garagem">Status</label>   <!-- {{this.value_status.map( sta => sta.id_status)}} -->
                <multiselect  v-model="value_status" required 
                  :options="statuss" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a status" label="status" track-by="status" name="status"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionado</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2">
                <label for="select-garagem">Tipo de corretiva</label>
                <multiselect  v-model="value_tipo" required 
                  :options="tipos" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione o tipo" label="tipo" track-by="tipo" name="tipo"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionado</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2">
                <label for="select-garagem">JB Status</label>   
                <multiselect  v-model="value_statusjb" required 
                  :options="situacaojb" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione o status JB" label="jbstatus" track-by="jbstatus" name="jbstatus"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} jJb status selecionado</span></template>
                </multiselect> 
              </b-col>  

              <b-col cols="2"  class="mb-0">
                <label  for="input-busca">Pesquisa no grid</label> 
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Carro ou RE"></b-form-input>              
              </b-col>      

<!--
              <b-col cols="1">
                <br>                 
                <b-button variant="primary" class="mr-2 mt-2" @click="limparFiltro()" title="Limpar filtro" v-b-tooltip.hover :disabled="carregando" >
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > <i class="fa fa-trash"></i>
                </b-button>                      
              </b-col>
-->



              <b-col cols="1">
                <br>                 
                <b-button variant="primary" class="mr-2 mt-2" @click="loadCorretivaMonitoramento()" :disabled="carregando" >
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                </b-button>                      
              </b-col>

            

              <b-col cols="1">
                <br>
                <b-button variant="warning" class="ml-5 mt-2" @click="novo()" v-b-modal.modal-multi-corretiva  >Novo</b-button>
              </b-col>

          </b-row>
    </b-form>

    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="tbldefeitos"  small hover striped sticky-header="660px"  :items="itemsFiltered" :fields="situacaocorretiva" >    
        <template slot="cell(actions)" slot-scope="data"  >

          <b-button @click="editCorretivaCabecalho(data.item)" v-b-modal.modal-multi-corretiva title="Editar Corretiva"  size="sm" variant="success" class="mr-2">                
              <i class="fa fa-exclamation-circle"></i>
          </b-button>

        </template>   
        
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div >        
    <b-modal id="modal-multi-corretiva"  hide-footer size="xl" title="Cadastro de ficha corretiva "  @close="novo()" no-close-on-esc no-close-on-backdrop  >
          <!-- -->
          <div >
             
              <!-- seleção --> 
            <b-row id="defeito-selecao" >
                <b-col cols="2">
                <label for="input-garagem">Garagem</label>  <!-- {{corretiva.id_filial}} -->
                <div>                
                  <b-form-select   
                    id="garagem"    
                    
                    v-model="corretiva.id_filial"                    
                    required                                                   
                    :options="garagens"
                    @change="loadLinhas()"
                    class="mb-3 "
                    text-field="garagem"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="2">
                <label for="input-garagem"> Corretiva</label>  <!-- {{corretiva.id_tipo}} -->


                <div>                
                  <b-form-select   
                    id="garagem"               
                    v-model="corretiva.id_tipo"                    
                    required                                                   
                    :options="tipos"
                    class="mb-3 "
                    text-field="tipo"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="2"  class="mb-2">
                <label for="input-live">Carro</label>  <!-- {{carro.placa}} -- {{carro.id_carro}} -->
                <b-form-input v-model="corretiva.carro" @keyup.enter="loadCarros()" required="required" placeholder="Nro carro"></b-form-input>              
              </b-col> 

              <b-col cols="2" >
                <label for="input-live">Solicitante</label> <!-- {{solicitante.id_funcionario_erp}} -->
                <b-form-input v-model="corretiva.reclamante" @keyup.enter="loadSolicitante()" required placeholder="RE"></b-form-input>              
              </b-col> 

            <b-col cols="2">
                <label for="input-garagem"> Linha</label>  <!-- {{corretiva.id_linha}} -->
                <div>                
                  <b-form-select   
                    id="tipo"               
                    v-model="corretiva.id_linha"                      
                    @change="loadLinhas()"
                    required                                                   
                    :options="linhas"
                    class="mb-3 "
                    text-field="linha"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

            <b-col cols="2"  class="mb-2">

              
                <label for="input-live">Nº da corretiva</label> 
                <b-form-input id="corretiva-nro" v-model="nrocorretiva.id_corretiva" readonly placeholder="Nro da Ficha"></b-form-input>              
            </b-col> 
            </b-row>

            <!--  via_cep  --->
            <b-row id="id-sos"  v-if="corretiva.id_tipo==3" class="pt-1 pb-1">
              <b-col cols="2"  class="mb-2">
                <label for="input-live">CEP S.O.S</label> <!-- {{  user.id_funcionario_erp  }} -->
                <b-form-input v-model="corretiva.cep" @keyup.enter="loadCep()" required placeholder="Cep"></b-form-input>              
              </b-col>

              <b-col cols="4"  class="mb-2">
                <label for="input-live">Logradouro</label> 
                <b-form-input v-model="viacep.logradouro"  required="required" placeholder="Rua"></b-form-input>              
              </b-col> 

              <b-col cols="1"  class="mb-2">
                <label for="input-live">Número</label> 
                <b-form-input v-model="corretiva.numero" required placeholder="Nº"></b-form-input>              
              </b-col> 

              <b-col cols="2"  class="mb-2">
                <label for="input-live">Bairro</label> 
                <b-form-input v-model="viacep.bairro" placeholder="Bairro"></b-form-input>              
              </b-col> 

              <b-col cols="2"  class="mb-2">
                <label for="input-live">Cidade</label> 
                <b-form-input v-model="viacep.localidade" required placeholder="Cidade"></b-form-input>              
              </b-col> 

              <b-col cols="1"  class="mb-2">
                <label for="UF">U.F</label> 
                <b-form-input v-model="viacep.uf" required placeholder="Uf"></b-form-input>              
              </b-col>               
            <!-- obs sos -->

              <b-col cols="2" >
                <label for="input-live">Socorrista</label> <!-- {{socorrista.id_funcionario_erp}} -->
                <b-form-input v-model="corretiva.socorrista_mot" @keyup.enter="loadSocorrista()" required placeholder="RE"></b-form-input>              
              </b-col> 

              <b-col cols="2"  class="mb-2">
                <label for="input-live">Carro Socorrista</label>  <!-- {{carro_socorrista.placa}} -- {{carro_socorrista.id_carro}} -->
                <b-form-input v-model="corretiva.carro_socorrista" @keyup.enter="loadCarrosSocorrista()" required="required" placeholder="Nro carro"></b-form-input>              
              </b-col> 

              <b-col cols="2"  class="mb-2">
                <label for="input-live">Carro Trocado</label>  <!-- {{carro_trocado.placa}} -- {{carro_trocado.id_carro}} -->
                <b-form-input v-model="corretiva.carro_trocado" @keyup.enter="loadCarrosTrocado()" required="required" placeholder="Nro carro"></b-form-input>              
              </b-col> 


              <b-col cols="6"  class="mb-0">
                <label for="input-live">Observações Socorrista</label>  
                <b-form-input v-model="corretiva.socorrista_obs"  required="required" placeholder="Observações"></b-form-input>              
              </b-col> 
              
            
            </b-row>

            


            <!--defeito informado pelo operador --> 

            <b-row id="id-informado" class="pt-1 pb-1">
                              <b-col cols="3">
                <label for="input-grupo-defeito">Grupo informado</label>  <!-- {{defeito.id_informado_grupo}} -->
                <div>                
                  <b-form-select   
                    id="grupo-defeito"               
                    v-model="defeito.id_informado_grupo"                    
                    required                                                   
                    :options="grupos"
                    @change="loadSubGrupoInformado()"
                    class="mb-3 "
                    text-field="grupo"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

                              <b-col cols="4">
                <label for="input-subgrupo-defeito">Subgrupo informado</label>  <!-- {{defeito.id_informado_subgrupo}} -->
                <div>                
                  <b-form-select   
                    id="subgrupo-defeito"               
                    v-model="defeito.id_informado_subgrupo"                    
                    required                                                   
                    :options="subgrupos"
                    @change="loadDefeitoInformado()"
                    class="mb-3 "
                    text-field="subgrupo"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="5">
                <label for="input-defeito-defeito">Defeito informado</label> <!-- {{defeito.id_informado_defeito}} --> 
                <div>                
                  <b-form-select   
                    id="id-informado-defeito"               
                    v-model="defeito.id_informado_defeito"                    
                    required                                                   
                    :options="defeitos"                    
                    class="mb-3 "
                    text-field="defeito"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="6"  class="mb-0">
                <label  for="input-live">Observações do Reclamante</label> 
                <b-form-input v-model="defeito.obs_informado_defeito"  required="required" placeholder="Observações"></b-form-input>              
              </b-col>

              <b-col cols="2" >
                <label for="input-live">Lider</label> -- {{lider.id_funcionario_erp}}  
                <b-form-input v-model="defeito.encarregado_re" @keyup.enter="loadLider()" required placeholder="RE"></b-form-input>              
              </b-col> 

              <b-col cols="2">
                <label for="input-live">Função Lider</label> 
                <b-form-input v-model="lider.funcao" readonly placeholder="Função"></b-form-input>              
              </b-col>  

              
              <b-col cols="2">                                              
                  <b-form-checkbox
                    id="corretiva-status" 
                    class="mb-3 mt-5"
                    v-model="defeito.defeito_cancelado"                  
                    name="checkbox-2"
                    value="true"
                    unchecked-value="false"
                    checked="true"
                  >                  
                  Defeito Cancelado
                  </b-form-checkbox>                
              </b-col>


            </b-row>




            <!--defeito diagnosticado pelo execuntante da tarefa --> 

            <b-row id="id-diagnosticado" class="pt-1 pb-1">
                              <b-col cols="3">
                <label for="input-grupo">Grupo diagnosticado</label>  <!-- {{defeitod.id_diagnosticado_grupo}} -->
                <div>                
                  <b-form-select   
                    id="garagem"               
                    v-model="defeito.id_diagnosticado_grupo"  
                    @change="loadSubGrupoDiagnosticado()"                  
                    required                                                   
                    :options="gruposd"
                    class="mb-3 "
                    text-field="grupo"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

                              <b-col cols="4">
                <label for="input-subgrupo">Subgrupo diagnosticado</label>  <!-- {{defeitod.id_diagnosticado_subgrupo}}  -->
                <div>                
                  <b-form-select   
                    id="garagem"               
                    v-model="defeito.id_diagnosticado_subgrupo" 
                    @change="loadDefeitoDiagnosticado()"              
                    required                                                   
                    :options="subgruposd"
                    class="mb-3 "
                    text-field="subgrupo"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

                              <b-col cols="5">
                <label for="input-diagnosticado-defeito">Defeito diagnosticado</label>  <!-- {{defeitod.id_diagnosticado_defeito}} -->
                <div>                
                  <b-form-select   
                    id="garagem"               
                    v-model="defeito.id_diagnosticado_defeito"                    
                    required                                                   
                    :options="defeitosd"
                    class="mb-3 "
                    text-field="defeito"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="6"  class="mb-0">
                <label  for="input-live">Observações do Executante</label> 
                <b-form-input v-model="defeito.obs_diagnosticado_defeito"  required="required" placeholder="Observações"></b-form-input>              
              </b-col>

              <b-col cols="2" >
                <label for="input-live">Executante</label>  <!-- {{executante.id_funcionario_erp}} -->
                <b-form-input v-model="defeito.executante_defeito" @keyup.enter="loadExecutante()" required placeholder="RE"></b-form-input>              
              </b-col> 

              <b-col cols="2">
                <label for="input-live">Função Executante</label> 
                <b-form-input v-model="executante.funcao" readonly placeholder="Função"></b-form-input>              
              </b-col> 






               <b-col cols="2">                                              
                  <b-form-checkbox
                    id="corretiva-causador" 
                    class="mb-0 mt-5 "
                    v-model="defeito.defeito_causador"                  
                    name="checkbox-2"
                    value="true"
                    unchecked-value="false"
                    checked="true"
                  >                  
                  Defeito Causador
                  </b-form-checkbox>                
              </b-col>
             


            </b-row>


            <!-- fechamento -->
            <b-row id="id-encerramento" cols="10" class="mt-2">

                            <b-col cols="2">
                <label for="input-live">Data Abertura</label>                 
                <b-input-group-text >{{moment(corretiva.dt_abertura).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') }}</b-input-group-text>
              </b-col> 

              <b-col cols="2">                
                <label for="input-live">Data fechamento</label>                  
                 <b-input-group-text >{{moment(corretiva.dt_fechamento).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') }}</b-input-group-text>
              </b-col> 

              <b-col cols="2">
                <label for="input-live">ERP Data importação</label> 
                <b-input-group-text >{{moment(corretiva.dt_jb_acesso).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') }}</b-input-group-text>                
              </b-col> 

              <b-col cols="2">
                <label for="input-live">ERP Nro Ficha</label> 
                <b-form-input v-model="lin.id_linha_erp" readonly placeholder="A18562022"></b-form-input>              
              </b-col> 

              <b-col cols="2">
                <label for="input-live">ERP Nro O.S</label> 
                <b-form-input v-model="lin.id_linha_erp"  readonly placeholder="ML28122022">  </b-form-input>              
              </b-col> 











              <b-col cols="1" class="mt-2 mb-2"> 
                <b-button class="mt-4" variant="success"  :disabled="carregando" @click="encerrarCabecalho(),novo()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Encerrar
                </b-button>                      
              </b-col> 

              

              <b-col cols="1" class="mt-2 mb-2"> 
                <b-button class="mt-4" variant="danger"  :disabled="carregando" @click="reset()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Gravar
                </b-button>                      
              </b-col> 

            </b-row>

             <!-- defeitos da corretiva -->
            <b-table id="tbcorretivadefeitos"  small hover striped sticky-header="220px"  :items="corretivaeditdefeito" :fields="listcorretivadefeitos" >    
              <template slot="cell(actions)" slot-scope="data"  >
                <b-button @click="editCorretivaCorpo(data.item),updateCabecalho()" title="Editar defeito"  size="sm" variant="success" class="mr-2">                
                  <i class="fa fa-exclamation-circle"></i>
                </b-button>
              </template>           
            </b-table>

          </div>          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>  

</template>

<script>
import { baseApiUrl, showError  } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { mapState } from 'vuex' 

export default {

    name: 'ManutencaoRfiLancamento', 
    
    /*
    computed: mapState(['user']),   
    */

    computed : { ... mapState (['user'],),
      itemsFiltered(){
        let valores = [];
       // const values = Object.values(obj);
        valores = this.corretivamonitoramento.filter((item) =>{
          return (
            item.carro.indexOf(this.search) >-1 || item.reclamante.indexOf(this.search) >-1 
          );
        });
        return valores
        }       
    } ,


    data: function() {
      
        return {            
            mode: 'save',
            carregando: false,
            atualizando: false, 
            
            corretiva:{},
            corretivas:[],
            
            
            carro:[],
            carro_socorrista:[],
            carro_trocado:[],

            viacep:[],
            
            
            grupo:{},
            grupos:[],
            subgrupo:{},
            subgrupos:[],
            defeito:{},
            defeitos:[],

                        
           // gruposd:[],
            gruposd:{},
            subgrupod:{},
            subgruposd:[],
            defeitod:{},
            defeitosd:[],

            solicitante:{},
            solicitantes:[],

            executante:{},
            executantes: [],  

            socorrista:{},
            socorristas:[],

            lider:{},
            lideres:[],

            linhas:[],

            nrocorretiva:[],

            corretivaeditdefeito:[],

            corretivamonitoramento:[],
            corretivamonitoramentos:[],

            statuss:[],
            situacaojb:[],

            value_carro:'',
            value_carro_socorrista:'',
            value_carro_trocado:'',
            value_cep:'',
            value_solicitante:'',
            value_executante:'', 
            value_socorrista:'',           
            value_status:[],
            value_statusjb:[],
            value_tipo:[],
            value_lider:'',
            

            //garagem:{}, 
            garagens: [],   // [] lista
            tipos:[] ,
            search:'',


            

            lin:{},
            
            value_garagem:[],// [] lista                         
            
            
            value_observacoes:'',
           
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            situacaocorretiva: [        

                 
              { key: 'id_filial', label: 'Garagem', sortable: true },                 
              { key: 'id_corretiva', label: 'Nro Corretiva', sortable: true },  
              { key: 'tipo', label: 'Tipo Corretiva', sortable: true }, 
              { key: 'qtd_defeito', label: 'Qtd defeitos', sortable: true },     
              { key: 'carro', label: 'Carro', sortable: true },                                
              { key: 'linha', label: 'Linha', sortable: true },                
              { key: 'reclamante', label: 'Reclamante', sortable: true },
              { key: 'status', label: 'Status', sortable: true },       
              { key: 'vlr_gasto', label: 'R$ gasto', sortable: true },                 

              { key: 'dt_abertura', label: 'Data Abertura', sortable: true, formatter: (value, key, corretivamonitoramento) => {
                    return moment(corretivamonitoramento.dt_abertura).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },

              { key: 'dt_fechamento', label: 'Data Fechamento', sortable: true, formatter: (value, key, corretivamonitoramento) => {
                 return moment(corretivamonitoramento.dt_fechamento).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },      

                            { key: 'dt_alteracao', label: 'Data Alteração', sortable: true, formatter: (value, key, corretivamonitoramento) => {
                    return moment(corretivamonitoramento.dt_alteracao).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },

                      { key: 'duracao2', label: ' Tempo Gasto', sortable: true },


                   
                    
                   
                
                
                

            

                { key: 'jbstatus', label: 'JB status', sortable: true },

              
              
      


              /*
              { key: 'duracao', label: 'Tempo execução #', sortable: true, formatFn: (value, key, corretivamonitoramento) => {
                    return moment(corretivamonitoramento.duracao).format('hh:mm:ss');} },        //:ms refere-se a miléssimo de segundos       
              */







              { key: 'dt_jb_acesso', label: 'Data JB acesso', sortable: true, formatter: (value, key, corretivamonitoramento) => {
                    return moment(corretivamonitoramento.dt_jb_acesso).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },


               

                
                { key: 'actions', label: 'Ações' },                

              
            ],


            //////// defeitos da corretiva
            listcorretivadefeitos: [                
                { key: 'id_corretiva', label: 'Nro Corretiva', sortable: true },                 

                { key: 'id_corretiva_corpo', label: 'Nro defeito', sortable: true },                 

                { key: 'informado_grupo', label: 'bgrupo indormado', sortable: true },
                { key: 'informado_subgrupo', label: 'Subgrupo indormado', sortable: true },
                { key: 'informado_defeito', label: 'Defeito informado', sortable: true },                                
                { key: 'defeito_cancelado', label: 'Cancelado', sortable: true,formatter: value => value ? 'Sim' : 'Não'  },                
                { key: 'diagnosticado_grupo', label: 'grupo diagnosticado', sortable: true },                                                
                { key: 'diagnosticado_subgrupo', label: 'Subgrupo diagnosticado', sortable: true },                                                
                { key: 'diagnosticado_defeito', label: 'Defeito diagnosticado', sortable: true },                 
                { key: 'defeito_causador', label: 'Causador', sortable: true,formatter: value => value ? 'Sim' : 'Não'  },
                { key: 'executante_defeito', label: 'Executante', sortable: true },                                
                { key: 'jb_status', label: 'JB', sortable: true },                                
                { key: 'defeito_dt_cadastro', label: 'Cadastro defeito', sortable: true, formatter: (value, key, corretivaeditdefeito) => {
                    return moment(corretivaeditdefeito.defeito_dt_cadastrado).format('DD/MM/YYYY - HH:mm:ss').replace('Data inválida','-') ; }  },                
                { key: 'actions', label: 'Ações' },                
            ]


        }        
    },

    filters: {
      dataFormatada(dt) {
        return dt.substring(0,4)
      }

    },

    components: {
        Multiselect
    },


    methods: {

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },

      limparFiltro(){
        this.search= ""
      },

      loadGaragens() {
          const url = `${baseApiUrl}/manutencao/rfi/garagem`  
          axios.get(url).then(res => {
            this.garagens = res.data.map(gar => {              
              return { ... gar, value:  gar.id_filial, garagem: gar.garagem }              
            })            
          })          
      },

      loadCorretivaStatus() {
          const url = `${baseApiUrl}/manutencao/corretiva/status`  
          axios.get(url).then(res => {
            this.statuss = res.data.map(st => {              
              return { ... st, value:  st.id_status, status: st.status }              
            })            
          })          
      },

      loadCorretivaStatusJb() {
          const url = `${baseApiUrl}/manutencao/corretiva/jbstatus`  
          axios.get(url).then(res => {
            this.situacaojb = res.data.map(jst => {              
              return { ... jst, value:  jst.id_jb_status, status: jst.jbstatus }              
            })            
          })          
      },

      loadTipos() {
          const url = `${baseApiUrl}/manutencao/corretiva/tipo`  
          axios.get(url).then(res => {
            this.tipos = res.data.map(tipo => {              
              return { ... tipo, value:  tipo.id_tipo, tipo: tipo.tipo }              
            })            
          })          
      },

      loadCarros() {          
          const url = `${baseApiUrl}/despachante/carro/${this.corretiva.carro}`
          axios.get(url).then(res => { 
            this.carro = res.data })          
      },

      loadCarrosSocorrista() {          
          const url = `${baseApiUrl}/despachante/carro/${this.corretiva.carro_socorrista}`
          axios.get(url).then(res => { 
            this.carro_socorrista = res.data })          
      },

      loadCarrosTrocado() {          
          const url = `${baseApiUrl}/despachante/carro/${this.corretiva.carro_trocado}`
          axios.get(url).then(res => { 
            this.carro_trocado = res.data })          
      },

      loadCep() {      
            axios.get('https://viacep.com.br/ws/'+ this.corretiva.cep+'/json/').then(res => { this.viacep = res.data })
      },
      

      loadLinhas() {
            let corpo = {    
                "id_filial": `${[this.corretiva.id_filial]}`            
            };
          const url = `${baseApiUrl}/planejamento/linha/cad`
          return axios.post(url,corpo).then(res => {
             this.linhas = res.data.map(linha => {
              return { ... linha, value: linha.id_linha, linha: linha.linha}
            })
          })          
        },

        loadGrupoInformado() {          
          const url = `${baseApiUrl}/manutencao/corretiva/grupo`
          axios.get(url).then(res => {
            this.grupos = res.data.map(grupo => {              
              return { ... grupo, value: grupo.id_grupo, grupo: grupo.grupo  }
            })
          })
        },
        
        loadSubGrupoInformado() { 
            let corpo = {    
                "id_grupo"    : `${[this.defeito.id_informado_grupo]}`     
            };         
          const url = `${baseApiUrl}/manutencao/corretiva/defeito/subgrupo`
          axios.post(url,corpo).then(res => {
            this.subgrupos = res.data.map(subgrupo => {              
              return { ... subgrupo, value: subgrupo.id_subgrupo, subgrupo: subgrupo.subgrupo  }
            })
          })
        },

        loadDefeitoInformado() { 
            let corpo = {                    
                "id_subgrupo"    : `${[this.defeito.id_informado_subgrupo]}`     
            };         
          const url = `${baseApiUrl}/manutencao/corretiva/corretivadefeito`
          axios.post(url,corpo).then(res => {
            this.defeitos = res.data.map(defeito => {              
              return { ... defeito, value: defeito.id_defeito, defeito: defeito.defeito  }
            })
          })
        },
               
        
        loadGrupoDiagnosticado() {          
          const url = `${baseApiUrl}/manutencao/corretiva/grupo`
          axios.get(url).then(res => {
            this.gruposd = res.data.map(grupod => {              
              return { ... grupod, value: grupod.id_grupo, grupo: grupod.grupo  }
            })
          })
        },
        
        loadSubGrupoDiagnosticado() { 
            let corpo = {    
                "id_grupo"    : `${[this.defeito.id_diagnosticado_grupo]}`     
            };         
          const url = `${baseApiUrl}/manutencao/corretiva/defeito/subgrupo`
          axios.post(url,corpo).then(res => {
            this.subgruposd = res.data.map(subgrupod => {              
              return { ... subgrupod, value: subgrupod.id_subgrupo, subgrupo: subgrupod.subgrupo  }
            })
          })
        },

        loadDefeitoDiagnosticado() { 
            let corpo = {                    
                "id_subgrupo"    : `${[this.defeito.id_diagnosticado_subgrupo]}`     
            };         
          const url = `${baseApiUrl}/manutencao/corretiva/corretivadefeito`
          axios.post(url,corpo).then(res => {
            this.defeitosd = res.data.map(defeitod => {              
              return { ... defeitod, value: defeitod.id_defeito, defeito: defeitod.defeito  }
            })
          })
        },        

        async loadExecutante() { 
            let corpo = {                             
            "re": `${this.defeito.executante_defeito}`                      
            };             
          const url = `${baseApiUrl}/escala/consulta/`
          axios.post(url,corpo).then(res => { this.executante = res.data })                         
        },  

        async loadSolicitante() { 
            let corpo = {                             
            "re": `${this.corretiva.reclamante}`                      
            };             
          const url = `${baseApiUrl}/escala/consulta/`
          axios.post(url,corpo).then(res => { this.solicitante = res.data })                         
        }, 

        async loadSocorrista() { 
            let corpo = {                             
            "re": `${this.corretiva.socorrista_mot}`                      
            };             
          const url = `${baseApiUrl}/escala/consulta/`
          axios.post(url,corpo).then(res => { this.socorrista = res.data })                         
        }, 

        async loadLider() { 
            let corpo = {                             
            "re": `${this.defeito.encarregado_re}`                      
            };             
          const url = `${baseApiUrl}/escala/consulta`
          axios.post(url,corpo).then(res => { this.lider = res.data })                                               
        },          
        
        async postCabecalho() { 
            let corpo = { 
            //"id_corretiva": `${ (this.nrocorretiva.id_corretiva)?[this.nrocorretiva.id_corretiva]:this.corretiva.id_corretiva }`,                
            "id_corretiva": `${ (this.corretiva.id_corretiva > 0 )?[this.corretiva.id_corretiva]:this.nrocorretiva.id_corretiva}`,                
            "id_filial": `${this.corretiva.id_filial}`,
            "id_carro": `${this.carro.id_carro}`,
            "id_tipo": `${this.corretiva.id_tipo}`,
            "id_usuario_erp": `${this.user.id_funcionario_erp}`,
            "id_motorista": `${[this.solicitante.id_funcionario_erp]}`,
            "id_linha": `${this.corretiva.id_linha}`,
            "cep": `${[this.corretiva.cep]}`,
            "logradouro": `${[this.viacep.logradouro]}`,
            "numero": `${[this.corretiva.numero]}`,
            "bairro": `${[this.viacep.bairro]}`,
            "localidade": `${[this.viacep.localidade]}`,
            "uf": `${[this.viacep.uf]}`,
            "id_socorrista": `${(this.socorrista.id_funcionario_erp)?[this.socorrista.id_funcionario_erp]:0}`,
            "id_carro_socorrista": `${(this.carro_socorrista.id_carro)?[this.carro_socorrista.id_carro]:0}`,
            "id_carro_trocado": `${(this.carro_trocado.id_carro)?[this.carro_trocado.id_carro]:0}`,
            "socorrista_providencias": `${[this.corretiva.socorrista_obs]}`,
            }; 
          const url = `${baseApiUrl}/manutencao/corretiva/inscabecalho`
         axios.post(url,corpo).then(() => {

            if(this.corretiva.id_corretiva < 0 || this.corretiva.id_corretiva != "undefined" || this.corretiva.id_corretiva != "undefined"){
            //  if(this.corretiva.id_corretiva < 0 || this.nrocorretiva.id_corretiva !="undefined"){  
              this.loadNroCorretiva()              
            }else{
              this.postCorpo()             
            }
              
           })
           .catch(showError)
        },

        /////////atualizar corretiva para em serviço
        async updateCabecalho() { 
            let corpo = {  
            "id_corretiva": `${ (this.nrocorretiva.id_corretiva)?[this.nrocorretiva.id_corretiva]:this.corretiva.id_corretiva }`,                            
            "id_usuario_erp_alt": `${this.user.id_funcionario_erp}`,
            "id_status": `${[2]}`          
            }; 
          const url = `${baseApiUrl}/manutencao/corretiva/updatecabecalho `
         axios.post(url,corpo).then(() => {   
           })
           .catch(showError)
        },

        /////////atualizar corretiva para em serviço
        async encerrarCabecalho() { 
            let corpo = {  
            "id_corretiva": `${ (this.nrocorretiva.id_corretiva)?[this.nrocorretiva.id_corretiva]:this.corretiva.id_corretiva }`,                            
            "id_usuario_erp_encerramento": `${this.user.id_funcionario_erp}`,
            "id_status": `${[4]}`          
            }; 
          const url = `${baseApiUrl}/manutencao/corretiva/encerrarcorretiva`
         axios.post(url,corpo).then(() => {   
           })
           .catch(showError)
        },

        /////////////////////////////////////////////////////////
        async postCorpo() { 
            let corpo = {                             
            "id_corretiva": `${ (this.nrocorretiva.id_corretiva)?[this.nrocorretiva.id_corretiva]:this.defeito.id_corretiva }`,    
            "id_corretiva_corpo": `${this.defeito.id_corretiva_corpo}`,
            "id_informado_grupo": `${this.defeito.id_informado_grupo}`,
            "id_informado_subgrupo": `${this.defeito.id_informado_subgrupo}`,
            "id_informado_defeito": `${this.defeito.id_informado_defeito}`,
            "obs_informado_defeito": `${[this.defeito.obs_informado_defeito]}`,

            "id_encarregado": `${(this.lider.id_funcionario_erp)?[this.lider.id_funcionario_erp]:0}`,            
            "defeito_cancelado": `${(this.defeito.defeito_cancelado)?[this.defeito.defeito_cancelado]:false}`,

            "id_executante": `${(this.executante.id_funcionario_erp)?[this.executante.id_funcionario_erp]:0}`,
            

            "id_diagnosticado_grupo": `${(this.defeito.id_diagnosticado_grupo)?[this.defeito.id_diagnosticado_grupo]:0}`,
            "id_diagnosticado_subgrupo": `${(this.defeito.id_diagnosticado_subgrupo)?[this.defeito.id_diagnosticado_subgrupo]:0}`,
            "id_diagnosticado_defeito": `${(this.defeito.id_diagnosticado_defeito)?[this.defeito.id_diagnosticado_defeito]:0}`,
            "obs_diagnosticado_defeito": `${[this.defeito.obs_diagnosticado_defeito]}` ,          
            "defeito_causador": `${(this.defeito.defeito_causador)?[this.defeito.defeito_causador]:false}`            
            }; 
          const url = `${baseApiUrl}/manutencao/corretiva/inscorpo`
          axios.post(url,corpo).then(() => {
               this.limparCorpo()
                this.loadCorretivaEditDefeito()
                this.$toasted.global.defaultSuccess()                
           })
           .catch(showError)
        },

      loadNroCorretiva() {        
            let corpo = {                             
              "id_usuario_erp": `${this.user.id_funcionario_erp}`                        
            }; 
          const url = `${baseApiUrl}/manutencao/corretiva/nrocabecalho`
          axios.post(url,corpo).then(res => { 

            if(this.nrocorretiva.id_corretiva !="undefined"){
              this.nrocorretiva = res.data              
              this.postCorpo()             
            }else{
              this.postCorpo()             
            }
          })
          .catch(showError)         
      },

      loadCorretivaEditDefeito() {        
            let corpo = {                             
              //"id_corretiva": `${ (this.corretiva.id_corretiva > 0 || this.defeito.id_corretiva > 0)?[this.defeito.id_corretiva]:this.nrocorretiva.id_corretiva }`,            
              "id_corretiva": `${ (this.nrocorretiva.id_corretiva)?[this.nrocorretiva.id_corretiva]:this.corretiva.id_corretiva }`,            
              //"id_corretiva": `${this.nrocorretiva.id_corretiva}`                        
            }; 
          const url = `${baseApiUrl}/manutencao/corretiva/editdefeito`
          axios.post(url,corpo).then(res => { 
            this.corretivaeditdefeito = res.data             
          })
          .catch(showError)         
      },

      ///////////////////////////////// 31/12/2022 as 20:17h
      editCorretivaCabecalho(corretiva){
            this.corretiva = { ...corretiva }
            this.loadCep()
            this.loadCarros()
            this.loadSolicitante()
            this.loadLinhas()
            this.loadSocorrista()
            this.loadCorretivaEditDefeito()
      },

      editCorretivaCorpo(defeito){
            this.defeito = { ...defeito }
            this.loadGrupoInformado()
            this.loadSubGrupoInformado()
            this.loadDefeitoInformado()
            this.loadSolicitante()
            this.loadLider()
            this.loadExecutante()

            this.loadGrupoDiagnosticado()
            this.loadSubGrupoDiagnosticado()
            this.loadDefeitoDiagnosticado()


            this.loadCorretivaEditDefeito()      
      },

      loadCorretivaMonitoramento() { 
          let corpo = {    
                "id_filial": `${[this.value_garagem.map(a => a.id_filial)]}`,            
                "id_status": `${[this.value_status.map(st => st.id_status)]}`,
                "id_jb_status": `${[this.value_statusjb.map(stj => stj.id_jb_status)]}`,                    
                "id_tipo": `${[this.value_tipo.map(tip => tip.id_tipo)]}`                       
          };
          const url = `${baseApiUrl}/manutencao/corretiva/monitoramento`
          axios.post(url,corpo).then(res => { 
            this.corretivamonitoramento = res.data             
          })
          .catch(showError)         
      },

      ///////////// 02/01/2023


      reset() {
          this.postCabecalho()
      },

      limparCorpo(){
        this.defeito =[]        
       // this.executante=[]
       this.lider=[]        
       this.value_executante=''
       // this.value_lider=''
       // this.nrocorretiva=[]
      },

      novo(){
        this.corretiva = []
        //this.defeito =[]
        //this.corretivamonitoramento =  {}
        this.corretivaeditdefeito = []
        this.nrocorretiva = []
        this.loadCorretivaMonitoramento()
      }
       
    },
    
    mounted() {      
      this.loadGaragens() 
      this.loadCorretivaStatus()
      this.loadCorretivaStatusJb() 
      this.loadTipos()      //27/12/2022 as 18:00
      this.loadGrupoInformado()
      this.loadGrupoDiagnosticado()
      
    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#modal-multi-corretiva___BV_modal_content_{
  background: rgb(227, 236, 227);
  /* border: 1px solid rgb(58, 20, 196) ; */
  border-radius: 8px;
  margin-bottom: 4px;  
}


#defeito-selecao{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196) ;
  border-radius: 8px;
  margin-bottom: 4px;  
}

#id-sos{  
  background: rgb(199, 222, 218);
  border: 1px solid red ;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-informado{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196) ;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-diagnosticado{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2) ;
  border-radius: 8px;
  margin-bottom: 4px;  
  
}

#id-encerramento{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2) ;
  border-radius: 8px;
  margin-bottom: 4px;  
  
}

#corretiva-nro{
  color: rgb(240, 8, 8);
  font-size: 18px;
  text-align: center;
  
}



#garagem{  
  font-size: 12px;
  text-align: center;
  
}





</style>